import { NgModule } from '@angular/core';
import { NZ_ICONS, NzIconModule } from 'ng-zorro-antd/icon';

import {
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  DashboardOutline,
  InboxOutline,
  FolderOutline,
  DeleteOutline,
  ContainerOutline,
  SearchOutline,
  CloseCircleOutline,
  ReloadOutline,
  ExportOutline,
  FileOutline,
  FilePdfOutline,
  FileImageOutline,
  FileTextOutline,
  CopyOutline,
  AndroidOutline,
  UndoOutline,
  TableOutline,
  ArrowUpOutline,
  ArrowDownOutline
} from '@ant-design/icons-angular/icons';

const icons = [
  MenuFoldOutline,
  MenuUnfoldOutline,
  DashboardOutline,
  FormOutline,
  InboxOutline,
  FolderOutline,
  DeleteOutline,
  ContainerOutline,
  SearchOutline,
  CloseCircleOutline,
  ReloadOutline,
  ExportOutline,
  FileOutline,
  FilePdfOutline,
  FileImageOutline,
  FileTextOutline,
  CopyOutline,
  AndroidOutline,
  UndoOutline,
  TableOutline,
  ArrowUpOutline,
  ArrowDownOutline
];

@NgModule({
  imports: [NzIconModule],
  exports: [NzIconModule],
  providers: [
    { provide: NZ_ICONS, useValue: icons }
  ]
})
export class IconsProviderModule {
}
